import { render, staticRenderFns } from "./chiaraStarterNavbar.vue?vue&type=template&id=1e888961&scoped=true&"
import script from "./chiaraStarterNavbar.vue?vue&type=script&lang=js&"
export * from "./chiaraStarterNavbar.vue?vue&type=script&lang=js&"
import style0 from "./chiaraStarterNavbar.vue?vue&type=style&index=0&id=1e888961&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e888961",
  null
  
)

export default component.exports